import React from 'react';
import { Redirect, Route, Switch} from 'react-router-dom';
import { History} from 'history';
import { Dialog, PageSection } from '../../components';
import { AddressRoute } from '../address/address-route';
import { AddressRouteApp } from '../address/address-route-app';
import { AddressRouteProduct } from '../address/address-route-product';
import { AmounttypeRoute } from '../amounttype/amounttype-route';
import { AppRoute } from './app-route';
import { CivilnumberRoute } from '../civilnumber/civilnumber-route';
import { CoabalanceRoute } from '../coabalance/coabalance-route';
import { CoaRoute } from '../coa/coa-route';
import { DivisionRoute } from '../division/division-route';
import { EventRoute } from '../event/event-route';
import { EventRouteTemplate } from '../event/event-route-template';
import { EventquizRoute } from '../eventquiz/eventquiz-route';
import { JournalgroupdetailRoute } from '../journalgroupdetail/journalgroupdetail-route';
import { JournalgroupRoute } from '../journalgroup/journalgroup-route';
import { JournalRoute } from '../journal/journal-route';
import { MenugroupRoute } from '../menugroup/menugroup-route';
import { MenuRoute } from '../menu/menu-route';
import { MessageRoute } from '../message/message-route';
import { MessageRouteTemplate } from '../message/message-route-template';
import { OwnerRoute } from '../owner/owner-route';
import { PaymenttypeRoute } from '../paymenttype/paymenttype-route';
import { PersonalinfoRoute } from '../personalinfo/personalinfo-route';
import { PersonalinfoRouteCustomer } from '../personalinfo/personalinfo-route-customer';
import { PersonalinfoRouteEmployee } from '../personalinfo/personalinfo-route-employee';
import { PersonalinfoRouteVendor } from '../personalinfo/personalinfo-route-vendor';
import { PersonalinfotypeRoute } from '../personalinfotype/personalinfotype-route';
import { PersonalinfotypeRouteCustomer } from '../personalinfotype/personalinfotype-route-customer';
import { PersonalinfotypeRouteEmployee } from '../personalinfotype/personalinfotype-route-employee';
import { PersonalinfotypeRouteVendor } from '../personalinfotype/personalinfotype-route-vendor';
import { ProductRoute } from '../product/product-route';
import { ProducttypeRoute } from '../producttype/producttype-route';
import { ProductgroupRoute } from '../productgroup/productgroup-route';
import { QuizanswerRoute } from '../quizanswer/quizanswer-route';
import { QuizquestionRoute } from '../quizquestion/quizquestion-route';
import { QuizresultRoute } from '../quizresult/quizresult-route';
import { RegionRoute } from '../region/region-route';
import { ReportRoute } from '../report/report-route';
import { ReportgroupRoute } from '../reportgroup/reportgroup-route';
import { ScheduleRoute } from '../schedule/schedule-route';
import { SectionRoute } from '../section/section-route';
import { SectionRouteQuiz } from '../section/section-route-quiz';
import { TransactionamountRoute } from '../transactionamount/transactionamount-route';
import { TransactiondetailRoute } from '../transactiondetail/transactiondetail-route';
import { TransactionpaymentRoute } from '../transactionpayment/transactionpayment-route';
import { TransactionRoute } from '../transaction/transaction-route';
import { TransactionRouteGeneral } from '../transaction/transaction-route-general';
import { TransactionRouteJournal } from '../transaction/transaction-route-journal';
import { TransactionRoutePurchase } from '../transaction/transaction-route-purchase';
import { TransactionRouteSales } from '../transaction/transaction-route-sales';
import { TransactiontypeRoute } from '../transactiontype/transactiontype-route';
import { UserRoute } from '../user/user-route';
import { UserRouteAuth } from '../user/user-route-auth';
import UserModel from '../user/user-model';
import MenugroupModel from '../menugroup/menugroup-model';
import BaseView from '../base/base-view.component';
import UserAuthSignin from '../user/user-auth-signin.component';
import UserAuthCheckToken from '../user/user-auth-checktoken.component';
import EventViewPublic from   '../event/event-view-public.component';
import ProductViewPublic from '../product/product-view-public.component';
import SectionViewPublic from '../section/section-view-public.component';
import TransactionEdit from '../transaction/transaction-edit.component';
import TransactionpaymentEdit from '../transactionpayment/transactionpayment-edit.component';
import AppViewDashboard from './app-view-dashboard.component';
import AppViewHome from './app-view-home';
import AppService from '../../services/app.service';

interface IProps {  
    history: History;
    root?: string;
 }

interface IState { 
    historyState: any;
    datarow: any;
    datarowMenugroup: MenugroupModel;
    openDialog: boolean;
    save: boolean;
 }

export default class AppRoutes extends React.Component<IProps, IState> { 

    constructor(props: IProps) { 
        super(props);
        this.state = { 
            historyState: null,
            datarow: null,
            datarowMenugroup: MenugroupModel.defaultValue(),
            openDialog: false,
            save: false,
        }
    }

    private userToken = AppService.getUrlQuery(this.props.history, 't');
    
    private path = () => {
        return '/' + (this.props.history.location.pathname.replace(this.props.root || '', '').split('/')?.[1] || '');
    }

    private isRoot() {
        const path = this.props.history.location.pathname;
        return path === '/' || path.includes(AppService.pathDashboard);
    }

    private isAllow() {
        return UserModel.isSignin() && this.state.datarowMenugroup?.menu.length > 0 && this.state.datarowMenugroup?.menu.findIndex((d: any) => (d.path?.split(';').includes(this.path()))) >= 0;
    }
    
    private isSignin() {
        if (UserModel.isSignin()) return true;
        AppService.historyState('authSignin', true);
        return false;
    }


    private onLoad = async(data: any) => {
        if (data.appbar) data.appbar.history = this.props.history;
        this.setState({ datarow: data});
    }

    private onLoadMenugroup = (data: any) => { 
        this.setState({datarowMenugroup: data});
    }

    private onSaveCheckToken = (data: any) => {
        this.setState({save: false});
        this.userToken = '';
        this.props.history.location.search = '';
        this.props.history.replace({});
    }

    public componentDidUpdate() {
        if (!UserModel.isSignin() && this.state.historyState?.authSignin) {
            AppService.historyState('authSignin', false, true);
            if (this.userToken) this.setState({save: true})
            else this.setState({openDialog: true});
        }

        if (UserModel.isSignin() && this.state.historyState?.nextUrl)
            this.props.history.push(this.state.historyState?.nextUrl, AppService.historyState('nextUrl', '', true));

        if (this.props.history.action === 'PUSH')
            AppService.historyState('historyLength', this.props.history.length);   
        
        if (this.isRoot()) 
            AppService.historyState('historyLengthRoot', this.props.history.length, false, true);
        
        const historyState = AppService.historyState();
        if (this.state.historyState !== historyState) {
            this.props.history.length = historyState?.historyLength;
            this.props.history.location.state = historyState;
            this.setState({historyState: historyState});

            if (!this.isRoot() && !this.props.root && this.state.datarow?.appbar) 
                this.setState({datarow: {...this.state.datarow, appbar: {}}});
        }
    }

    render() {
        return (
            //editable..
            <>
            <PageSection
            id = 'Top'
            appbar = {this.state.datarow?.appbar}
            section = {[
                {maxWidth: this.isRoot()? 'xl' : (this.state.datarow?.maxWidth || 'lg'),
                                    
                content: [ {child: 
                    <>
                    {!UserModel.isSignin() && this.userToken &&
                    <UserAuthCheckToken history={this.props.history} code={this.userToken} save={this.state.save} onSave={this.onSaveCheckToken}/>
                    }
                    <Dialog open={this.state.openDialog} maxWidth='xs' onClose={() => this.setState({openDialog: false})}>
                        <UserAuthSignin history={this.props.history} root='/' onSave={() => this.setState({openDialog: false})} disableBackButton disableAutoBack disableCard/>
                    </Dialog>

                    {!this.props.root?
                        //General routes
                        <Switch>
                        <Route path='/' key='home' render={(params) => <AppViewHome {...params} onLoad={this.onLoad}/>} exact/>
                        <Route path={AppService.pathDashboard} render={(params) => this.isSignin() && <AppViewDashboard {...params} root={AppService.pathDashboard} onLoad={this.onLoad}/>}/>
                        <Route path='/event/:uid' render={(params) => this.isSignin() && <EventViewPublic {...params} key={params.history.location.key} uid={params.match.params.uid} onLoad={this.onLoad}/> }/>
                        <Route path='/event' render={(params) => UserModel.isSignin() && <EventViewPublic {...params} key={params.history.location.key} onLoad={this.onLoad}/>}/>
                        <Route path='/product' render={(params) => <ProductViewPublic {...params} onLoad={this.onLoad}/>}/>
                        <Route path='/invite/:id' render={(params) => <SectionViewPublic {...params} id={+params.match.params.id} onLoad={this.onLoad} disableAppbar/>}/>
                        <Route path='/transaction' render={(params) => UserModel.isSignin() && AppService.historyState()?.id && <TransactionEdit {...params} caption='Transaction' actions={{transactionpayment: ['upload']}} disableFields={['status', 'owner', 'transactionType', 'employee', 'customer', 'vendor', 'image', 'division', 'schedule', 'transactionamount', 'journal', 'invoice']} readonlyFields={['status', 'transaction', 'transactiondetail', 'transactionpayment']}/> }/>
                        <Route path='/transactionpayment' render={(params) => UserModel.isSignin() && AppService.historyState()?.id && <TransactionpaymentEdit {...params} caption='Transaction Payment' viewMode='upload' /> }/>
                        <Route path='/user*' render={(params) => <UserRouteAuth {...params} isSignin={UserModel.isSignin()}/>}/>
                        <Route path='/*' render={() => <Redirect to='/' />}/>
                        </Switch>
                    :
                        //Dashboard routes
                        this.state.historyState?.menugroupId > 0 &&
                        <>
                        <BaseView history={this.props.history} id={this.state.historyState.menugroupId} caption=' ' 
                            endPointFilter={MenugroupModel.endPointFilter2()} model={MenugroupModel} onLoad={this.onLoadMenugroup} disableBackButton disableCard/>              
                            
                            {this.isAllow() && 
                            <>
                            <AddressRoute root={ this.props.root }/>
                            <AddressRouteApp root={ this.props.root }/>
                            <AddressRouteProduct root={ this.props.root }/>
                            <AmounttypeRoute root={ this.props.root }/> 
                            <AppRoute root={ this.props.root }/>
                            <CivilnumberRoute root={ this.props.root }/>
                            <CoabalanceRoute root={ this.props.root }/>
                            <CoaRoute root={ this.props.root }/>
                            <DivisionRoute root={ this.props.root }/> 
                            <EventRoute root={ this.props.root }/> 
                            <EventRouteTemplate root={ this.props.root }/> 
                            <EventquizRoute root={ this.props.root }/>
                            <JournalgroupdetailRoute root={ this.props.root }/>
                            <JournalgroupRoute root={ this.props.root }/>
                            <JournalRoute root={ this.props.root }/>
                            <MenugroupRoute root={ this.props.root }/>
                            <MenuRoute root={ this.props.root }/>
                            <MessageRoute root={ this.props.root }/> 
                            <MessageRouteTemplate root={ this.props.root }/> 
                            <OwnerRoute root={ this.props.root }/>  
                            <PaymenttypeRoute root={ this.props.root }/>
                            <PersonalinfoRoute root={ this.props.root }/> 
                            <PersonalinfoRouteCustomer root={ this.props.root }/> 
                            <PersonalinfoRouteEmployee root={ this.props.root }/> 
                            <PersonalinfoRouteVendor root={ this.props.root }/> 
                            <PersonalinfotypeRoute root={ this.props.root }/> 
                            <PersonalinfotypeRouteCustomer root={ this.props.root }/> 
                            <PersonalinfotypeRouteEmployee root={ this.props.root }/> 
                            <PersonalinfotypeRouteVendor root={ this.props.root }/> 
                            <ProductRoute root={ this.props.root }/> 
                            <ProducttypeRoute root={ this.props.root }/> 
                            <ProductgroupRoute root={ this.props.root }/> 
                            <QuizanswerRoute root={ this.props.root }/> 
                            <QuizquestionRoute root={ this.props.root }/> 
                            <QuizresultRoute root={ this.props.root }/> 
                            <RegionRoute root={ this.props.root }/>
                            <ReportRoute root={ this.props.root }/>
                            <ReportgroupRoute root={ this.props.root }/>
                            <SectionRoute root={ this.props.root }/>
                            <SectionRouteQuiz root={ this.props.root }/>
                            <ScheduleRoute root={ this.props.root }/>
                            <TransactionamountRoute root={ this.props.root }/> 
                            <TransactiondetailRoute root={ this.props.root }/> 
                            <TransactionpaymentRoute root={ this.props.root }/> 
                            <TransactionRoute root={ this.props.root }/> 
                            <TransactionRouteGeneral root={ this.props.root }/> 
                            <TransactionRouteJournal root={ this.props.root }/> 
                            <TransactionRoutePurchase root={ this.props.root }/> 
                            <TransactionRouteSales root={ this.props.root }/> 
                            <TransactiontypeRoute root={ this.props.root }/> 
                            <UserRoute root={ this.props.root }/> 
                            <UserRouteAuth root={ this.props.root } isSignin/> 
                            </>}
                        </>
                    }
                    </>
                }]
                },
            ]}
            />
            </>
        );
     }
 }